import { getContext, setContext } from 'svelte';
const troisContextKey = {};
const troisInternalContextKey = {};
export const getTroisContext = () => getContext(troisContextKey);
export const getTroisInternalContext = () => getContext(troisInternalContextKey);
export const setTroisContext = (troiContext) => setContext(troisContextKey, troiContext);
export const setTroisInternalContext = (troisInternalContext) => setContext(troisInternalContextKey, troisInternalContext);
